import { Component, OnInit } from '@angular/core';
import {ConfService} from '../conf.service';
import {MatSnackBar} from '@angular/material';
import {ConnecttocrudService} from '../connecttocrud.service';
import {LeftpanelComponent} from '../leftpanel/leftpanel.component';
import {EmailtemplateListenerService} from '../emailtemplate-listener.service';
import {Router} from '@angular/router';
import {AccountInfoService} from '../user/account-info.service';

declare let $;

@Component({
  selector: 'app-manageemailtemplates',
  templateUrl: './manageemailtemplates.component.html',
  styleUrls: ['./manageemailtemplates.component.scss']
})
export class ManageemailtemplatesComponent implements OnInit {

  templates: any;

  constructor(public platform: LeftpanelComponent,
              private confPost: ConfService,
              private _service: ConnecttocrudService,
              public accountInfoService: AccountInfoService,
              public emailTemplatesListenerInstance: EmailtemplateListenerService,
              public router: Router) { }

  ngOnInit() {

    if (this.platform.loadingForTheFirstTime === true && this.platform.loadingForTheFirstTimeCompleted === false) {
      this.platform.initialisePlatform();
    }

    $(document).ready(function () {
      $('#myInput').on('keyup', function () {
        const value = $(this).val().toString().toLowerCase();
        $('.emailtemplate').filter(function () {
          $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1);
          return true;
        });
      });
    });

    this.confPost.getData('campaign', 'campaign', 'v1', 'emailTemplate', 'partner=' + localStorage.getItem('partner') + '&account=' + localStorage.getItem('account')).subscribe(response => {
      this.templates = response;
    });
  }

  deleteTemplate(template) {
    if (confirm('This action is irreversible. Do you still want to delete ' + template['name'] + ' ?')) {
      Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'emailtemplate_delete_clicked', 'INFO', 200, 'OK', '', '', '', this.router.url)).then(response => {
        const payloadToSend = {
          actions: response
        };
        this.emailTemplatesListenerInstance.emailTemplatesListener.emit({
          type: 'audit',
          id: localStorage.getItem('IdOfSession'),
          payload: payloadToSend
        });
      });
      this._service.deleteEmailTemplate('v1', 'campaign', 'campaign', 'emailTemplate', template['id']).subscribe(data => {
        Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'emailtemplate_delete_success', 'INFO', data.status, data.statusText, '', {id: template['id'], template: template}, data, this.router.url)).then(resp => {
          const payloadToSend = {
            actions: resp
          };
          this.emailTemplatesListenerInstance.emailTemplatesListener.emit({
            type: 'audit',
            id: localStorage.getItem('IdOfSession'),
            payload: payloadToSend
          });
        });
        this.platform.openSnackBar('Template deleted successfully.', 'Success', {
          duration: 5000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
        this.confPost.getData('campaign', 'campaign', 'v1', 'emailTemplate', 'partner=' + localStorage.getItem('partner') + '&account=' + localStorage.getItem('account')).subscribe(response => {
          this.templates = response;
        });
      }, error => {
        Promise.resolve(this.platform.generateActionPayloadForAudit(true, 'emailtemplate_delete_failed', 'ERROR', error.status, error.statusText, this.platform.returnErrorMessage(error), {id: template['id'], template: template}, error, this.router.url)).then(response => {
          const payloadToSend = {
            actions: response
          };
          this.emailTemplatesListenerInstance.emailTemplatesListener.emit({
            type: 'audit',
            id: localStorage.getItem('IdOfSession'),
            payload: payloadToSend
          });
        });
        this.platform.openSnackBar('Cannot delete template. Please try again', 'Error', {
          duration: 5000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
      });
    } else {
    }
  }

  createPaddingRight() {
    document.getElementById('view:email-templates').style.paddingRight = '400px';
  }

  removePaddingRight() {
    document.getElementById('view:email-templates').style.paddingRight = '0px';
  }
}
